export const AssistedRule = {
    "Logout":"Logout",
    "GetAgentID": "GetAgentId",
    "GetUserName":"getUserName",
    "GetExtension":"GetExtension",
    "ChangePassword":"ChangePassword",
    "sendClientChatMessage":"sendClientChatMessage",
    "getSupervisorsToChat":"getSupervisorsToChat",
    "getChatHistory":"getChatHistory",
    "GetCampaignsRelated":"GetCampaignsRelated",
    "makeManualCall":"makeManualCall",
    "getLastCallData":"getLastCallData",
    "getCallHistory":"getCallHistory",
    "getUnavailables":"getUnavailables",
    "getUnavailableHistory":"getUnavailableHistory",
    "exitAssistedMode":"exitAssistedMode",
    "cancelManualCallReprogramed":"cancelManualCallReprogramed"
};


// WEBPACK FOOTER //
// ./src/BusinessRule/AssistedRule.js